module.exports = __webpack_public_path__ + "img/balearic-islands.999fa777.svg";